import { Appointment, Task } from '../types';

const patients = [
  'Vitali Diel',
  'Lisa Meier',
  'Michael Franken',
  'Thomas Meyer',
  'Erik Filbert',
  'Johann Schäfer'
];

const titles = ['Kontrolluntersuchung', 'Blutentnahme', 'Impfung', 'Beratung', 'Nachuntersuchung', 'Rezept', 'Laborbesprechung', 'Routine', 'Untersuchung'];
const types = ['Routine', 'Labor', 'Dringend', 'Kontrolltermin', 'Ersttermin'];
const colors = ['#4CAF50', '#2196F3', '#FF9800', '#9C27B0', '#F44336', '#E91E63', '#607D8B', '#00BCD4', '#795548', '#3F51B5'];

const daySlots = ['11:00', '12:30', '14:00', '15:30', '17:00', '18:00'];

const getWeekStart = (date: Date): Date => {
  const d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  const day = d.getUTCDay();
  const diff = (day === 0 ? -6 : 1 - day);
  d.setUTCDate(d.getUTCDate() + diff);
  return d;
};

const formatDate = (d: Date): string => d.toISOString().split('T')[0];

export const appointmentsData: Appointment[] = (() => {
  const appointments: Appointment[] = [];
  let id = 1;

  const weekStart = getWeekStart(new Date());

  for (let dayOffset = 0; dayOffset < 14; dayOffset++) {
    const date = new Date(weekStart);
    date.setUTCDate(weekStart.getUTCDate() + dayOffset);
    const dateStr = formatDate(date);

    daySlots.forEach((time, slotIndex) => {
      const patientIndex = (slotIndex + dayOffset) % patients.length;
      const patient = patients[patientIndex];
      appointments.push({
        id: id++,
        time,
        date: dateStr,
        title: titles[(slotIndex + dayOffset) % titles.length],
        patient,
        type: types[(slotIndex + dayOffset) % types.length],
        color: colors[patientIndex % colors.length],
        notifyTIMessenger: true,
      });
    });
  }

  return appointments.sort((a, b) => {
    const dateCompare = a.date.localeCompare(b.date);
    if (dateCompare !== 0) return dateCompare;
    return a.time.localeCompare(b.time);
  });
})();

export const hours = Array.from({ length: 13 }, (_, i) => i + 7);

export const tasksData: Task[] = [
  { id: 1, title: 'Rezepte ausdrucken', completed: false, createdAt: new Date().toISOString() },
  { id: 2, title: 'Laborergebnisse abrufen', completed: false, createdAt: new Date().toISOString() },
  { id: 3, title: 'Patientenakte aktualisieren', completed: true, createdAt: new Date().toISOString() },
  { id: 4, title: 'Bestellung aufgeben', completed: false, createdAt: new Date().toISOString() },
  { id: 5, title: 'Rückruf erledigen', completed: false, createdAt: new Date().toISOString() },
];
